// extracted by mini-css-extract-plugin
export default {"Wrapper":"AccreditationView_Wrapper__azDQl","Content":"AccreditationView_Content__M5Bvf"};